import type { ReportData, ReportSeverityKey } from '@ipfabric/utils';
import type { IntentVerificationRuleFormValues } from 'components/ApiTable/components/IntentVerification/IntentVerificationRuleForm';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { selectTableId } from 'components/ApiTable/model/selectors/selectTableId';
import { formatGroupFilter } from 'components/Table/components/AdvancedFilter/formatFilter';
import { isFilterInvalid } from 'components/Table/components/AdvancedFilter/validateRule';

interface SaveIntentVerificationRuleCommand {
  values: IntentVerificationRuleFormValues;
}

export const saveIntentVerificationRule: ApiTableCommandFactory<
  SaveIntentVerificationRuleCommand
> = (cmdContext) => async (command) => {
  const tableId = selectTableId(cmdContext.getState());
  const {
    endpoint: { apiEndpoint },
    ruleContext,
  } = cmdContext.getState();

  const groups = command.values.groups.map((group) => ({ id: group }));
  const checks = Object.entries(command.values.checks).reduce<
    ReportData['checks']
  >((acc, [index, value]) => {
    if (!isFilterInvalid(value)) {
      acc[index as ReportSeverityKey] = formatGroupFilter(value, ruleContext);
    }

    return acc;
  }, {});

  await cmdContext.api.request<ReportData>({
    url: command.values.id ? `/reports/${command.values.id}` : '/reports',
    method: command.values.id ? 'PATCH' : 'POST',
    data: {
      apiEndpoint: apiEndpoint,
      name: command.values.name,
      column: command.values.column,
      descriptions: command.values.descriptions,
      defaultColor: command.values.defaultColor,
      checks,
      groups,
      webEndpoint: tableId,
    },
  });

  cmdContext.notifications.showNotification({
    type: 'success',
    message: 'Report saved',
  });
};
